'use strict';

export default class UserChangePWCtrl {
  user = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  message = '';
  submitted = false;
  AuthSvc;

  constructor(AuthSvc, ToastrSvc) {
    this.AuthSvc = AuthSvc;
    this.ToastrSvc = ToastrSvc;
  }

  changePassword(form) {
    this.submitted = true;

    if(form.$valid) {
      this.AuthSvc.changePassword(this.user.oldPassword, this.user.newPassword)
        .then(() => {
          this.ToastrSvc.success('Password successfully changed.');
        })
        .catch(() => {
          this.user.oldPassword = '';
          this.ToastrSvc.error('Incorrect password - please retry');
        });
    }
  }
}

UserChangePWCtrl.$inject = ['AuthSvc', 'ToastrSvc'];
